import React from 'react'
import "./footer.css"
const index = () => {
  return (
    <div className="footerContainer">
        <p style={{textAlign:'center'}}>Copyright © Nikesh Pyakurel || All Rights Reserved</p>
    </div>
  )
}

export default index


